import React from 'react';
import Spinner from '../../Spinner';

interface LoadingRowProps {
  colSpan: number;
}

const LoadingRow: React.FC<LoadingRowProps> = ({ colSpan }) => {
  return (
    <tr className="odd">
      <td valign="top" colSpan={colSpan} className="dataTables_empty">
        <Spinner />
      </td>
    </tr>
  );
};

export default LoadingRow;
